import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { MsalInterceptor } from '@azure/msal-angular';
// import { AuthDebugHttpInterceptor } from './auth-debug-http.interceptor';
// import { AuthDebugPostMsalHttpInterceptor } from './auth-debug-post-msal-http.interceptor';
import { CurrentOrganizationContextInterceptor } from './current-organization-context.interceptor';
import { HttpErrorInterceptor } from './http-errror.interceptor';
import { ParseDateInterceptor } from './parse-date.interceptor';

export const INTERCEPTORS = [
    /*     {
        provide: HTTP_INTERCEPTORS,
        useClass: AuthDebugHttpInterceptor,
        multi: true,
    }, */
    {
        provide: HTTP_INTERCEPTORS,
        useClass: MsalInterceptor,
        multi: true,
    },
    {
        provide: HTTP_INTERCEPTORS,
        useClass: CurrentOrganizationContextInterceptor,
        multi: true,
    },
    /*     {
        provide: HTTP_INTERCEPTORS,
        useClass: AuthDebugPostMsalHttpInterceptor,
        multi: true,
    }, */
    {
        provide: HTTP_INTERCEPTORS,
        useClass: HttpErrorInterceptor,
        multi: true,
    },
    {
        provide: HTTP_INTERCEPTORS,
        useClass: ParseDateInterceptor,
        multi: true,
    },
];
